import { createContext, useContext } from 'react';

export interface BannerMessageContextProps {
  bannerMessage: string | null;
  setDismissed: (dismissed: boolean) => void;
}

const BannerMessageContext = createContext<BannerMessageContextProps>({
  bannerMessage: null,
  setDismissed: () => {},
});

const useBannerMessageContext = () => useContext(BannerMessageContext);
export { BannerMessageContext, useBannerMessageContext };
